import type { Filter, FilterDataSearchDynamic } from '@/app/common/filters/core/filtersTypes.ts';
import { FilterSearchDynamicPill } from '@/app/common/filters/types/searchDynamic/FilterSearchDynamicPill.ts';
import type { FilterTypeBehaviour } from '@/app/common/filters/types/filterTypeDefinition.ts';

const dataOf = (filter: Filter) => filter.data as FilterDataSearchDynamic;

export const searchDynamicType: FilterTypeBehaviour = {
  pillLabels: FilterSearchDynamicPill,
  serialise: (filter) => dataOf(filter).value || undefined,
  isSelected: (filter) => !!dataOf(filter).value,
  resetValue: (filter) => ({ ...filter, data: { ...dataOf(filter), value: '' } }),
  selectedOptions: (filter) => {
    const { value } = dataOf(filter);
    return value ? [{ label: value, value, selected: true }] : [];
  },
};
